import { render, staticRenderFns } from "./add-device-soon-available.vue?vue&type=template&id=15cf032c&"
import script from "./add-device-soon-available.js?vue&type=script&lang=js&"
export * from "./add-device-soon-available.js?vue&type=script&lang=js&"
import style0 from "./add-device-soon-available.css?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
